__turbopack_context__.v({
  "html-block": "rich-text-block-module-scss-module__GP8bbq__html-block",
  "html-block--no-paragraph-gutters": "rich-text-block-module-scss-module__GP8bbq__html-block--no-paragraph-gutters",
  "html-block--on-dark": "rich-text-block-module-scss-module__GP8bbq__html-block--on-dark",
  "html-block--standalone": "rich-text-block-module-scss-module__GP8bbq__html-block--standalone",
  "standalone-section": "rich-text-block-module-scss-module__GP8bbq__standalone-section",
  "standalone-section--separator-bottom": "rich-text-block-module-scss-module__GP8bbq__standalone-section--separator-bottom",
  "standalone-section--separator-top": "rich-text-block-module-scss-module__GP8bbq__standalone-section--separator-top",
});
